import type { FormConfig } from '@tencent/wb-ext-form';
import { FormItemName, FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';

export const FORM_CONFIGS: FormConfig[] = [
    {
        name: FormItemName.SHOW_MASTER_SHAPE,
        type: FormItemType.CHECKBOX,
        label: FormItemLabelName.SHOW_MASTER_SHAPE,
        defaultValue: true,
        options: {
            fillType: 'tick',
        },
    },
];
